import React, { useState } from 'react';

const PARTS = [
  { name: 'Gear', img: 'https://cdn-icons-png.flaticon.com/512/1046/1046857.png', spot: 0 },
  { name: 'Belt', img: 'https://cdn-icons-png.flaticon.com/512/1046/1046870.png', spot: 1 },
  { name: 'Lever', img: 'https://cdn-icons-png.flaticon.com/512/1046/1046862.png', spot: 2 },
];

function FixMachinePuzzle({ onComplete, xpReward = 30, coinReward = 10 }) {
  const [placed, setPlaced] = useState({}); // { spot: partName }
  const [dragged, setDragged] = useState(null);
  const [solved, setSolved] = useState(false);

  const handleDragStart = (name) => setDragged(name);
  const handleDrop = (spot) => {
    if (!dragged) return;
    setPlaced(p => ({ ...p, [spot]: dragged }));
    setDragged(null);
  };
  const handleDragOver = e => e.preventDefault();

  const allCorrect = PARTS.every(part => placed[part.spot] === part.name);

  const handleCheck = () => {
    if (allCorrect) {
      setSolved(true);
      setTimeout(() => onComplete({ xp: xpReward, coins: coinReward }), 1200);
    }
  };

  return (
    <div style={{ padding: 16, textAlign: 'center', minWidth: 280, maxWidth: 400 }}>
      <h3 style={{ fontWeight: 700, fontSize: 20, marginBottom: 12 }}>Fix the Machine</h3>
      <div style={{ color: '#555', marginBottom: 18 }}>Drag the missing parts to the correct spots to fix the machine.</div>
      {/* Machine image with drop spots */}
      <div style={{ display: 'flex', justifyContent: 'center', gap: 12, marginBottom: 18 }}>
        {[0, 1, 2].map(spot => {
          const partName = placed[spot];
          const part = PARTS.find(p => p.name === partName);
          const correct = part && part.spot === spot;
          return (
            <div
              key={spot}
              onDrop={() => handleDrop(spot)}
              onDragOver={handleDragOver}
              style={{
                width: 64,
                height: 64,
                border: `2px dashed ${part ? (correct ? '#22c55e' : '#ef4444') : '#e5e7eb'}`,
                borderRadius: 12,
                background: part ? (correct ? '#bbf7d0' : '#fecaca') : '#f8fafc',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                margin: 2,
                transition: 'all 0.2s',
                boxShadow: '0 2px 8px rgba(34,197,94,0.07)',
              }}
            >
              {part ? <img src={part.img} alt={part.name} style={{ width: 40, height: 40 }} /> : <span style={{ color: '#bbb', fontSize: 24 }}>?</span>}
            </div>
          );
        })}
      </div>
      {/* Parts to drag */}
      <div style={{ display: 'flex', justifyContent: 'center', gap: 18, marginBottom: 18 }}>
        {PARTS.map(part => (
          <img
            key={part.name}
            src={part.img}
            alt={part.name}
            draggable
            onDragStart={() => handleDragStart(part.name)}
            style={{ width: 48, height: 48, borderRadius: 10, border: '2px solid #e5e7eb', background: '#f8fafc', boxShadow: '0 2px 8px rgba(34,197,94,0.07)', opacity: Object.values(placed).includes(part.name) ? 0.4 : 1, cursor: 'grab', transition: 'opacity 0.2s' }}
          />
        ))}
      </div>
      <button className="gogig-card-btn" style={{ width: 180 }} onClick={handleCheck} disabled={solved || !allCorrect}>{solved ? 'Fixed!' : 'Check'}</button>
      {solved && <div style={{ color: '#22c55e', fontWeight: 700, marginTop: 12 }}>Machine running! You earned {xpReward} XP and {coinReward} Coins!</div>}
    </div>
  );
}

export default FixMachinePuzzle; 